/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotoeffectshadow4Inputs */

const en_aiflowphotoeffectshadow4 = /** @type {(inputs: Aiflowphotoeffectshadow4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shadow`)
};

const de_aiflowphotoeffectshadow4 = /** @type {(inputs: Aiflowphotoeffectshadow4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schatten`)
};

/**
* | output |
* | --- |
* | "Shadow" |
*
* @param {Aiflowphotoeffectshadow4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotoeffectshadow4 = /** @type {((inputs?: Aiflowphotoeffectshadow4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotoeffectshadow4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotoeffectshadow4(inputs)
	return de_aiflowphotoeffectshadow4(inputs)
});
export { aiflowphotoeffectshadow4 as "aiFlowPhotoEffectShadow" }